import Vue from 'vue'
import Router from 'vue-router'

import Session from "../pages/Session.vue";
import ErrorMessage from "../pages/Error.vue";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/error',
      name: 'error',
      component: ErrorMessage,
    },
    {
      path: '/session',
      name: 'session',
      component: Session,
      alias: '/',
    },
  ]
})
